import { reactive } from "vue";

export const store = reactive({
  productOfTradeCollection: [],
  aberturaCaixa: false,
  fechamentoAsCegas: false,
  verificaEstoque: false,
  desconsiderarEstoqueCondicional: false,
  pafNFCe: false,
  ordenarItemAdicionadoPorUltimoPDV: false,
  // Integração com o aplicativo local Balança — captura automática de peso.
  balancaHabilitada: false,
  balancaHost: "127.0.0.1",
  balancaPorta: 51234,
  balancaCasasDecimais: 3,
  balancaConectada: false,
  balancaEstado: "idle",
  balancaPesoTempoReal: 0,
  balancaModelo: "",
  balancaAdicionandoItem: false,
  balancaPesoProcessado: false,
});
